import React from "react";
import { CARD_NAMES } from "./config";
import { useCard } from "./hooks/useCard";
import { PaymentModeSelection } from "./components/PaymentModeSelection";
import BackButton from "../../../shared/components/BackButton";
import { Box } from "@material-ui/core";
import { FixedInstalmentAmount } from "./components/FixedInstalmentAmount";
import { PaymentMode } from "@nemuru-eng/js-api-client";

export const Card = () => {
  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: CARD_NAMES.PAYMENT_MODE_SELECTION,
      show: () => true,
    },
    {
      id: CARD_NAMES.FIXED_INSTALMENT_AMOUNT,
      show: (allStepValues) => {
        return (
          allStepValues[CARD_NAMES.PAYMENT_MODE_SELECTION].paymentMode ===
          PaymentMode.FIXED_INSTALLMENT
        );
      },
    },
  ];

  const {
    stepGroupStepToShow,
    submitStep,
    onBack,
    backButtonVisible,
    getStepData,
  } = useCard({
    STEP_GROUP_STEPS_ARRAY,
  });

  return (
    <>
      <Box className="appear-anim" style={{ position: "absolute" }}>
        <BackButton onBack={onBack} show={backButtonVisible} />
      </Box>
      {stepGroupStepToShow === CARD_NAMES.PAYMENT_MODE_SELECTION && (
        <PaymentModeSelection onSubmitForm={submitStep} data={getStepData()} />
      )}
      {stepGroupStepToShow === CARD_NAMES.FIXED_INSTALMENT_AMOUNT && (
        <FixedInstalmentAmount onSubmitForm={submitStep} data={getStepData()} />
      )}
    </>
  );
};
